module.exports = __webpack_public_path__ + "static/media/01_BaerbelWagner_webfinal.e26d790f.jpg";